import { render, staticRenderFns } from "./ServiceModel.vue?vue&type=template&id=9a0b246e&scoped=true&"
import script from "./ServiceModel.vue?vue&type=script&lang=ts&"
export * from "./ServiceModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0b246e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VContainer,VFadeTransition,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0b246e')) {
      api.createRecord('9a0b246e', component.options)
    } else {
      api.reload('9a0b246e', component.options)
    }
    module.hot.accept("./ServiceModel.vue?vue&type=template&id=9a0b246e&scoped=true&", function () {
      api.rerender('9a0b246e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/infodayco/service-model/views/ServiceModel.vue"
export default component.exports